import LayersOutlinedIcon from "@mui/icons-material/LayersOutlined";

// The sidebar container forces `& svg { font-size: 20px }`, which shrinks MUI
// icons; the custom SVG nav icons ignore it because they carry width/height="24".
// Pin width/height to 24 so Line Items matches its neighbours (Campaigns, etc.).
export default function LineItemsNavIcon() {
  return <LayersOutlinedIcon sx={{ width: 24, height: 24 }} />;
}
